<button mat-button [matMenuTriggerFor]="clientMenu"
		aria-label="Select a client"
		[disabled]="isClientListDisabled$ | async">
	<span *ngIf="(client$ | async) as client; else noClient" class="client-name">
		{{ client }}
	</span>
	<mat-icon class="ml-8" title="Open menu">expand_more</mat-icon>
</button>

<div class="client-actions ml-32" *ngIf="(client$ | async) as client">
	<!-- <button mat-button color="primary">
		View Sponsor Portal
	</button> -->
</div>


<mat-menu #clientMenu="matMenu">
	<button mat-menu-item *ngFor="let client of (clients$ | async)" (click)="selectClient(client)" class="client-name">
		{{ client }}
	</button>
</mat-menu>

<ng-template #noClient>
	No client selected
</ng-template>
